var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#155747",
    d: "M6 1.667c1.098 0 2 .901 2 2v2H4v-2c0-1.099.9-2 2-2m3.333 4v-2A3.34 3.34 0 0 0 5.999.333a3.34 3.34 0 0 0-3.333 3.334v2h-.667C1.263 5.667.666 6.264.666 7v5.333c0 .737.597 1.334 1.333 1.334h8c.737 0 1.334-.597 1.334-1.334V7c0-.736-.597-1.333-1.334-1.333zM1.999 7h8v5.333H2z"
  })));
};
export default SvgLock;